import { render, staticRenderFns } from "./title-back-date.vue?vue&type=template&id=4a9acd3b&"
import script from "./title-back-date.vue?vue&type=script&lang=js&"
export * from "./title-back-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports